"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fileBinaryChunkedReader = /** @class */ (function () {
    function fileBinaryChunkedReader() {
    }
    //https://stackoverflow.com/questions/25810051/filereader-api-on-big-files
    /*
    
    before use in main html file in BODY section please add following code line

    <input type="file" id="id-image-uploader" style="display:none" />

    */
    fileBinaryChunkedReader.init = function () {
        var _this = this;
        document.getElementById(this._id).onchange = function (e) {
            if (!e.target.files.length) {
                return;
            }
            _this.initReadSingleFile(e);
        };
    };
    fileBinaryChunkedReader.getUploadChunkSize = function () {
        var uploadSize = this.__upload_chunk_size;
        if (uploadSize > this._file.size) {
            uploadSize = this._file.size;
        }
        if ((this._offset + uploadSize) > this._file.size) {
            uploadSize = this._file.size - this._offset;
        }
        return uploadSize;
    };
    fileBinaryChunkedReader.initReadSingleFile = function (sender) {
        var _this = this;
        this._file = sender.target.files[0];
        if (this._file.size > this._max_file_size) {
            if (this._cb_onError) {
                this._cb_onError("File is too big");
            }
            return;
        }
        this._fileReader = new FileReader();
        this._fileReader.onload = function (ev) {
            if (_this._cb_onDataChunk) {
                _this._cb_onDataChunk(_this._fileReader.result.toString(), _this._file.name, _this._offset, _this._file.size);
            }
            _this._offset += _this.getUploadChunkSize();
            if (_this._offset >= _this._file.size) {
                _this._cb_onDone(_this._file.name, _this._file.size);
            }
        };
        this._fileReader.onerror = function () {
            _this._cb_onError("Cannot read file");
        };
        if (this._cb_onInit) {
            this._cb_onInit(this._file.name, this._file.size);
        }
    };
    fileBinaryChunkedReader.readFileChunk = function () {
        if (this._offset >= this._file.size) { // + 
            return;
        }
        // if()
        var slice = this._file.slice(this._offset, this._offset + this.getUploadChunkSize());
        this._fileReader.readAsBinaryString(slice);
    };
    fileBinaryChunkedReader.setOnError = function (cb) {
        this._cb_onError = cb;
    };
    fileBinaryChunkedReader.setOnInit = function (cb) {
        this._cb_onInit = cb;
    };
    fileBinaryChunkedReader.setOnDone = function (cb) {
        this._cb_onDone = cb;
    };
    fileBinaryChunkedReader.setOnDataChunk = function (cb) {
        this._cb_onDataChunk = cb;
    };
    fileBinaryChunkedReader.showSelector = function () {
        this._offset = 0;
        this._file = null;
        this._fileReader = null;
        var fileInput = document.getElementById(this._id);
        // fileInput.replaceWith(fileInput['val']('').clone(true));
        fileInput['value'] = "";
        fileInput.click();
    };
    fileBinaryChunkedReader.getMaxUploadSizeBytes = function () {
        return this._max_file_size;
    };
    fileBinaryChunkedReader.getUploadSizeChunkBytes = function () {
        return this.__upload_chunk_size;
    };
    fileBinaryChunkedReader._id = "id-image-uploader";
    fileBinaryChunkedReader._max_file_size = 1024 * 1024 * 100; //1 GB default max upload size
    fileBinaryChunkedReader.__upload_chunk_size = 1024 * 50; //1 KB max chunk size
    fileBinaryChunkedReader._offset = 0;
    fileBinaryChunkedReader._cb_onInit = null;
    fileBinaryChunkedReader._cb_onDataChunk = null;
    fileBinaryChunkedReader._cb_onError = null;
    fileBinaryChunkedReader._cb_onDone = null;
    return fileBinaryChunkedReader;
}());
exports.fileBinaryChunkedReader = fileBinaryChunkedReader;



//////////////////
// WEBPACK FOOTER
// ./src/shared/helpers/fileBinaryChunkedUploadCtl.ts
// module id = 328
// module chunks = 0